import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Cacheable } from "ts-cacheable";

import { environment } from "@environments/environment";

import { TotalAffiliate } from "../Interfaces/total-affiliate.interface";

const { enlineaBackendUrl } = environment;

@Injectable({
  providedIn: "root",
})
export class HomeRepository {
  constructor(private http: HttpClient) {}

  @Cacheable()
  public getHomePage(): Observable<any> {
    return this.http.get<any>(`${enlineaBackendUrl}/api/ArteHome?spinner=true`);
  }

  @Cacheable()
  public getMetricasHomePage(url: string, metrica: unknown): Observable<any> {
    return this.http.get(`${enlineaBackendUrl}${url}${metrica}`);
  }

  @Cacheable()
  public getTotalAffiliate(): Observable<TotalAffiliate> {
    return this.http.get(`${enlineaBackendUrl}/api/Dashboard/TotalAffiliate`);
  }
}
